// ═══ 말소 상세 (plan.md §6 · B3 리뷰 §3.7) — 대화 없음, [차량 상세 보기]·영업 칸 없음 ═══
// MalsoDetailBody 하나가 두 폭을 섬긴다: ≥1024 말소 탭 우측(.ss-detail-pane 은 MalsoHome 이 감싼다) · ≤1023 이 파일의
// default 페이지(뒤로 + 제목). 순서 = FinalWeb2 `.det`: 헤더 → 단계 → 요청 서류(보류 해제) → 말소증 → 수거 정보 · 신청 정보 → [신청 취소].
// 데이터: api.getRequest + api.myDocRequests 중 같은 carId·미완료. 도착 예정·기사 전화는 상세 응답에
// 없어서 목록 행(row)이 있을 때만 그린다(리뷰 P8). 신청 취소는 하드 삭제라 대기·접수에서만(P9).
// props(Body): { id, row, user, showToast, onChanged }
// 전체 모드 '말소 진행' 패널도 이 Body 를 쓴다(Jin 10/29): onDeleted(삭제 후 — 없으면 말소 탭으로 이동) ·
// fallback(조회 실패 시 대신 그릴 것 — 다른 사업자 건 등) · flush(패널이 여백을 주므로 안쪽 여백 없음).
// 대행사·하위 회사가 서로 넣은 신청(request.requestedByMe === false): [신청 취소]·[보류 해제] 없음(서버 403 — 신청 회사만),
// 서류 올리기는 그대로. 신청 정보에 '거래처'(brokerLogic.unitLabel) · '신청'(신청 회사명, 남이 넣은 때만) 칸.
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { T, R, FONT } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { useIsDesktop } from '../../simple/useDesktop';
import { getRequest, myDocRequests, submitDocFiles, unholdRequest, deleteRequest } from '../api';
import { describeSimpleError } from '../../simple/errors';
import ErrorText from '../../simple/parts/ErrorText';
import LtrText from '../../simple/parts/LtrText';
import ConfirmSheet from '../../simple/parts/ConfirmSheet';
import MalsoStepper from '../parts/MalsoStepper';
import MalsoCertCard from '../parts/MalsoCertCard';
import { MalsoStatusPill } from '../parts/MalsoRow';
import { unitLabel } from '../brokerLogic';

var MALSO_LIST = '/main/m/malso';
var CANCELABLE = { '대기': 1, '접수': 1 };

var CANCEL_TYPE_KEY = { '수출말소': 'reqAdminCancelTypeExport', '폐차말소': 'reqAdminCancelTypeScrap' };

var col = { display: 'flex', flexDirection: 'column', gap: 10 };
var dh = { borderRadius: R.lg, padding: '16px 20px', background: T.navy, color: T.card, display: 'flex', alignItems: 'flex-start', gap: 12 };
var t1 = { fontSize: FONT.title, fontWeight: 800, letterSpacing: '-.3px' };
var t2 = { fontSize: FONT.body, opacity: .75, marginTop: 2, display: 'flex', flexWrap: 'wrap', gap: '2px 6px' };
var card = { background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card };
var sec = Object.assign({}, card, { padding: '12px 16px' });
var h4 = { margin: '0 0 6px', fontSize: 12, fontWeight: 700, color: T.sub };
var two = { display: 'flex', flexWrap: 'wrap', gap: 10 };
var fieldRow = { display: 'flex', justifyContent: 'space-between', gap: 10, fontSize: FONT.body, padding: '3px 0' };
var fieldLabel = { color: T.muted, flex: 'none' };
var fieldValue = { color: T.ink, textAlign: 'end', minWidth: 0, overflowWrap: 'anywhere' };
var docCard = Object.assign({}, sec, { background: T.warnTint, border: '1px solid ' + T.warnBd });
var docTitle = { fontWeight: 800, color: T.warn, fontSize: FONT.body, marginBottom: 6 };
var docRow = { display: 'flex', alignItems: 'center', gap: 10, padding: '4px 0', fontSize: FONT.body, color: T.ink };
var btnBase = { minHeight: 40, padding: '0 16px', borderRadius: R.md, fontSize: 13, fontWeight: 700, cursor: 'pointer',
  fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, boxSizing: 'border-box' };
var navyBtn = Object.assign({}, btnBase, { background: T.navy, border: '1px solid ' + T.navy, color: T.card });
var warnBtn = Object.assign({}, btnBase, { background: T.warn, border: '1px solid ' + T.warn, color: T.card });
var ghostDanger = Object.assign({}, btnBase, { background: T.card, border: '1px solid ' + T.dangerBd, color: T.danger, width: '100%' });
var hidden = { display: 'none' };
var muted = { padding: '40px 0', textAlign: 'center', fontSize: FONT.body, color: T.muted };
var titleRow = { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 13 };
var backBtn = { width: 30, height: 30, borderRadius: R.sm, border: '1px solid ' + T.bd, background: T.card,
  color: T.body, cursor: 'pointer', fontFamily: 'inherit', display: 'grid', placeItems: 'center', flex: 'none', padding: 0 };
var h2 = { fontSize: FONT.title, fontWeight: 800, color: T.ink, letterSpacing: '-.3px', margin: 0 };

function Field(props) {
  return (<div style={fieldRow}>
    <span style={fieldLabel}>{props.label}</span>
    <span style={fieldValue}>{props.ltr ? <LtrText>{props.value}</LtrText> : props.value}</span>
  </div>);
}

function short(v) { return v ? String(v).slice(0, 16) : ''; }

export function MalsoDetailBody(props) {
  var t = useT();
  var navigate = useNavigate();
  var location = useLocation();
  var isDesktop = useIsDesktop();
  var id = props.id;
  var row = props.row || null;
  var onChanged = props.onChanged;
  var showToast = props.showToast || function () {};
  var stD = useState(null); var data = stD[0], setData = stD[1];
  var stL = useState(true); var loading = stL[0], setLoading = stL[1];
  var stE = useState(null); var loadErr = stE[0], setLoadErr = stE[1];
  var stA = useState(null); var actionErr = stA[0], setActionErr = stA[1];
  var stB = useState(false); var busy = stB[0], setBusy = stB[1];
  var stC = useState(false); var confirmOpen = stC[0], setConfirmOpen = stC[1];
  // 2-pane 은 같은 Body 에 id 만 바뀌어 들어온다 — 늦게 도착한 이전 id 응답이 새 차량 화면(취소 버튼 게이트)을 덮지 않게.
  var idRef = useRef(id);
  idRef.current = id;

  var load = useCallback(function () {
    return Promise.all([getRequest(id), myDocRequests()]).then(function (res) {
      if (String(idRef.current) !== String(id)) return;
      var d = res[0] || {};
      var carId = Number(d.car && d.car.id);
      var docs = (Array.isArray(res[1]) ? res[1] : []).filter(function (x) {
        return carId > 0 && Number(x.carId) === carId && x.status !== '완료';
      });
      setData({ request: d.request || {}, car: d.car || {}, services: Array.isArray(d.services) ? d.services : [],
        hasMalsoCert: !!d.hasMalsoCert, docs: docs });
      setLoadErr(null);
      setLoading(false);
    }, function (e) {
      if (String(idRef.current) !== String(id)) return;
      setData(null);
      setLoadErr(e);
      setLoading(false);
    });
  // setter 는 useState 가 보장하는 안정 참조 — 배열 구조분해라 린터가 못 알아본다(DetailBody.js 와 같은 사정).
  }, [id, setData, setLoadErr, setLoading]);

  useEffect(function () {
    setLoading(true);
    setData(null);
    setActionErr(null);
    setConfirmOpen(false);
    load();
  }, [load, setLoading, setData, setActionErr, setConfirmOpen]);

  var run = function (promise, after) {
    setBusy(true);
    setActionErr(null);
    promise.then(function () { setBusy(false); after(); }, function (e) { setBusy(false); setActionErr(e); });
  };

  var changed = function () { load(); if (onChanged) onChanged(); };

  var onPick = function (docId, e) {
    var files = Array.prototype.slice.call((e.target && e.target.files) || []);
    e.target.value = '';
    if (!files.length || busy) return;
    run(submitDocFiles(docId, files), function () {
      showToast(t('cancelDetailDocAttachDone', { count: files.length }));
      changed();
    });
  };
  var onUnhold = function () { if (!busy) run(unholdRequest(id), changed); };
  var onDelete = function () {
    if (busy) return;
    setConfirmOpen(false);
    run(deleteRequest(id), function () {
      showToast(t('cancelHistoryCancelDone'));
      if (onChanged) onChanged();
      if (props.onDeleted) { props.onDeleted(); return; }
      navigate(MALSO_LIST + location.search);     // 하드 삭제 — :id 를 지워 404 재조회를 막는다(2-pane·페이지 공통, 칩·기간 유지)
    });
  };

  var rootStyle = isDesktop && !props.flush ? Object.assign({}, col, { padding: '14px 18px' }) : col;
  if (loading) return <div style={rootStyle}><div style={muted}>{t('commonLoading')}</div></div>;
  if (!data) return props.fallback || <div style={rootStyle}><ErrorText>{describeSimpleError(t, loadErr)}</ErrorText></div>;

  var r = data.request, car = data.car, status = r.status;
  var mine = r.requestedByMe !== false;   // 구 서버(키 없음) = 내 신청
  var hold = status === '보류';
  var unit = unitLabel(r, t);
  var cancelType = CANCEL_TYPE_KEY[r.cancelType] ? t(CANCEL_TYPE_KEY[r.cancelType]) : (r.cancelType || '');
  var meta = [car.carType, cancelType, r.agencyName].filter(Boolean).map(function (s, i) { return <span key={i}>{s}</span>; });
  if (r.requestDate) meta.push(<LtrText key="date">{r.requestDate}</LtrText>);
  var serviceNames = data.services.map(function (s) { return s && s.name; }).filter(Boolean).join(', ');

  var staff = r.assignedStaffName ? r.assignedStaffName + (row && row.staffPhone ? ' · ' + row.staffPhone : '') : '';
  var pickupFields = [
    staff ? <Field key="staff" label={t('cancelDetailStaffLabel')} value={staff} /> : null,
    row && row.eta_at ? <Field key="eta" label={t('cancelDetailEta')} value={short(row.eta_at)} ltr /> : null,
    r.pickupAddress ? <Field key="addr" label={t('settingsCompanyFieldAddress')} value={r.pickupAddress} /> : null,
    r.pickedUpAt ? <Field key="picked" label={t('cancelAgencyStatusPickedUp')} value={short(r.pickedUpAt)} ltr /> : null
  ].filter(Boolean);

  return (<div data-part="malso-detail" style={rootStyle}>
    <div style={dh}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={t1}><LtrText>{car.carNo || '-'}</LtrText></div>
        <div style={t2}>
          {meta.map(function (el, i) {
            return <React.Fragment key={i}>{i ? <span aria-hidden="true">·</span> : null}{el}</React.Fragment>;
          })}
        </div>
      </div>
      <MalsoStatusPill status={status} />
    </div>

    <div style={card}><MalsoStepper status={status} holdReason={r.holdReason} /></div>

    {data.docs.length || (hold && mine) ? (<div data-part="malso-docs" style={docCard}>
      {/* 수동 보류(보강요청 없음)는 사유가 단계 바 아래에 있으므로 여기엔 [보류 해제] 만 */}
      {data.docs.length ? <div style={docTitle}>{t('cancelDetailDocUrgentHint')}</div> : null}
      {data.docs.map(function (dr) {
        var names = Array.isArray(dr.requestedDocs) ? dr.requestedDocs : [];
        return (<div key={dr.id} data-doc-request={dr.id} style={{ marginBottom: 10 }}>
          {names.map(function (n, i) {
            return (<div key={i} style={docRow}>
              <span style={{ flex: 1, minWidth: 0, fontWeight: 700 }}>{n}</span>
              {dr.status === '요청' ? <span style={{ color: T.warn, fontWeight: 700 }}>{t('cancelDetailDocRowNeeded')}</span> : null}
            </div>);
          })}
          <label style={Object.assign({}, warnBtn, { marginTop: 6, opacity: busy ? 0.6 : 1 })}>
            {t('carDetailDocActionUpload')}
            <input type="file" multiple data-action="doc-upload" style={hidden} disabled={busy}
              onChange={function (e) { onPick(dr.id, e); }} />
          </label>
        </div>);
      })}
      {hold && mine ? <button type="button" data-action="unhold" style={Object.assign({}, navyBtn, { width: '100%' })} disabled={busy}
        onClick={onUnhold}>{t('cancelUnholdBtn')}</button> : null}
    </div>) : null}

    {status === '완료' && data.hasMalsoCert ? <MalsoCertCard id={id} showToast={showToast} /> : null}

    <div style={two}>
      {pickupFields.length ? (<div data-part="malso-pickup" style={Object.assign({}, sec, { flex: '1 1 220px' })}>
        <h4 style={h4}>{t('cancelDetailPickupInfoSection')}</h4>
        {pickupFields}
      </div>) : null}
      <div data-part="malso-request" style={Object.assign({}, sec, { flex: '1 1 220px' })}>
        <h4 style={h4}>{t('cancelAgencyDetailSectionRequest')}</h4>
        <Field label={t('cancelAgencyDetailFieldVin')} value={car.vin || '-'} ltr />
        <Field label={t('cancelDetailOwner')} value={car.owner || '-'} />
        <Field label={t('reqAdminFieldCancelType')} value={cancelType || '-'} />
        <Field label={t('fixReqAgencyLabel')} value={r.agencyName || '-'} />
        {unit ? <Field label={t('malsoModeBrokerClients')} value={unit} /> : null}
        {!mine && r.companyName ? <Field label={t('malsoModeBrokerRequesterLabel')} value={r.companyName} /> : null}
        <Field label={t('cancelDetailRequestedAt')} value={r.requestDate || '-'} ltr />
        {serviceNames ? <Field label={t('extraSvcTitle')} value={serviceNames} /> : null}
        {r.memo ? <Field label={t('cancelAgencyDetailFieldMemo')} value={r.memo} /> : null}
      </div>
    </div>

    {actionErr ? <ErrorText>{describeSimpleError(t, actionErr)}</ErrorText> : null}

    {CANCELABLE[status] && mine ? <button type="button" data-action="withdraw" style={ghostDanger} disabled={busy}
      onClick={function () { setConfirmOpen(true); }}>{t('cancelHistoryCancelBtn')}</button> : null}

    <ConfirmSheet open={confirmOpen} title={t('cancelHistoryCancelTitle')} sub={t('cancelHistoryCancelConfirm')}
      confirmLabel={t('cancelHistoryCancelBtn')} onClose={function () { setConfirmOpen(false); }} onConfirm={onDelete} />
  </div>);
}

function MalsoDetail(props) {
  var t = useT();
  var navigate = useNavigate();
  var location = useLocation();
  var id = useParams().id;
  // 뒤로 = 들어온 화면(홈 · 기간을 고른 말소 탭)으로. 주소로 바로 열었으면(첫 기록) 말소 탭.
  var back = function () { if (location.key === 'default') navigate(MALSO_LIST); else navigate(-1); };
  return (<div>
    <div style={titleRow}>
      <button type="button" style={backBtn} aria-label={t('actionBack')} onClick={back}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" /></svg>
      </button>
      <h2 style={h2}>{t('cancelHistoryDetailTitle')}</h2>
    </div>
    <MalsoDetailBody id={id} user={props.user} showToast={props.showToast} />
  </div>);
}

export default MalsoDetail;
